import React, { useState } from 'react';
import { menuItem } from './Data';
import { Container } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { BiLoader, BiX } from "react-icons/bi";
import { exceptionLog, getBankData } from '../../utils/common';
import { makeRequest } from '../../utils/makeRequest';
import * as urls from "../../utils/urlConst";
import toastNotify from '../../utils/toastNotify';

type menuBarProps = {
    isMenuBar: boolean,
    setIsMenuBar: any
}

const MenuBar = ({ isMenuBar, setIsMenuBar }: menuBarProps) => {
    const screenWidth = useSelector((state: any) => state.layout.currentScreenWidth);
    const bankLogo = useSelector((state: any) => state.layout.bankLogo);
    const bankDtl: any = getBankData();
    const [isLoader, setIsLoader] = useState<boolean>(false);

    const downloadUserManual = async () => {
        try {
            setIsLoader(true);

            const payload = {};
            const config = {};

            await makeRequest('POST', urls.getUserManual, payload, config).then((result) => {
                if (result.STATUS === '0') {
                    const response = result.RESPONSE[0];

                    const base64 = "data:application/pdf;base64," + response.UserManual;

                    const link = document.createElement("a");
                    link.href = base64;
                    link.setAttribute("download", "CMS_Client_User_Manual.pdf"); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                } else {
                    toastNotify(result.MESSAGE, 'error');
                };
            })
        } catch (error: any) {
            if (error.status !== 403) {
                await exceptionLog(error, "Download Manual", "N");
            }
        } finally {
            setIsLoader(false);
        }
    };

    return (
        <>
            {isMenuBar && <div className={`${screenWidth <= 875 && "bg-mobile"}`}></div>}

            {screenWidth >= 875 ?
                <div className="header-Container">
                    <Container className="d-flex p-2" >
                        {menuItem.map((items) => {
                            const { Icon } = items;
                            return (
                                <React.Fragment key={items.id}>
                                    {items.name === "User Manual" && bankDtl.UserManualType === "R" ?
                                        <div
                                            className="mainMenu d-flex justify-content-center align-items-center"
                                            style={{ cursor: "pointer" }}
                                            onClick={downloadUserManual}
                                        >
                                            {!isLoader ? <><Icon className='manuIcon' />
                                                <span className="ms-1 text-sm menuText">{items.name}</span></> : <><BiLoader className='icon-loader me-1' /> Downloading...</>}
                                        </div>
                                        :
                                        <NavLink
                                            to={items.link}
                                            className="mainMenu d-flex justify-content-center align-items-center"
                                        >
                                            <Icon className='manuIcon' />
                                            <span className="ms-1 text-sm menuText">{items.name}</span>
                                        </NavLink>
                                    }
                                </React.Fragment>
                            )
                        })}
                    </Container>
                </div>
                :
                <div className={`sidebar ${screenWidth <= 875 && isMenuBar ? 'MobileSidebar' : "hideSidebar"}`}>
                    {isMenuBar &&
                        <div className='top-section'>
                            <Link to="/dashboard" className="logo" onClick={() => setIsMenuBar(false)}>
                                <img src={bankLogo.mainLogo} alt="logo" style={{ width: bankLogo.mainLogoWidth, height: bankLogo.mainLogoheight }} />
                            </Link>

                            {screenWidth <= 875 &&
                                <div className="close-menu">
                                    <Button className="border-0 bg-transparent" onClick={() => setIsMenuBar(false)}>
                                        <BiX />
                                    </Button>
                                </div>}
                        </div>
                    }

                    <div className="main-menu" style={{ marginTop: 60 }}>
                        <ul>
                            {menuItem.map((items) => {
                                const { Icon } = items;
                                return (
                                    <React.Fragment key={items.id}>
                                        {items.name === "User Manual" && bankDtl.UserManualType === "R" ?
                                            <li className='my-2'>
                                                <div className='menu-link' style={{ cursor: "pointer" }} onClick={() => { setIsMenuBar(false); downloadUserManual() }}>
                                                    <span className="menu-icon" style={{ flexGrow: 0 }}>
                                                        <Icon />
                                                    </span>
                                                    <div className="text-sm menu-title" style={{ flexGrow: 1 }}>
                                                        {items.name}
                                                    </div>
                                                </div>
                                            </li>
                                            :
                                            <li className='my-2 '>
                                                <NavLink className='menu-link' to={items.link} onClick={() => setIsMenuBar(false)}>
                                                    <span className="menu-icon" style={{ flexGrow: 0 }}>
                                                        <Icon />
                                                    </span>
                                                    <div className="text-sm menu-title" style={{ flexGrow: 1 }}>
                                                        {items.name}
                                                    </div>
                                                </NavLink>
                                            </li>
                                        }
                                    </React.Fragment>
                                )
                            })}
                        </ul>
                    </div>
                </div >
            }
        </>
    )
}

export default MenuBar
